import { render, staticRenderFns } from "./WineDetailsOrders.vue?vue&type=template&id=1efabca0&scoped=true"
import script from "./WineDetailsOrders.vue?vue&type=script&lang=js"
export * from "./WineDetailsOrders.vue?vue&type=script&lang=js"
import style0 from "./WineDetailsOrders.vue?vue&type=style&index=0&id=1efabca0&prod&scoped=true&lang=css"
import style1 from "./WineDetailsOrders.vue?vue&type=style&index=1&id=1efabca0&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efabca0",
  null
  
)

export default component.exports